module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.dynamicFlag) ? _c('div', {
    staticClass: "bigDiv"
  }, [_c('div', {
    staticClass: "userDiv"
  }, [_c('div', {
    staticClass: "avatar"
  }, [(_vm.dynamic.user === undefined) ? _c('img', {
    attrs: {
      "src": require("../../assets/images/wutouxiang.png")
    }
  }) : _vm._e(), _vm._v(" "), (_vm.dynamic.user !== undefined) ? _c('img', {
    attrs: {
      "src": _vm.dynamic.user.avatar
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "user"
  }, [_c('span', [_vm._v(_vm._s(_vm.dynamic.user.nickName))]), _vm._v(" "), _c('span', [_c('img', {
    attrs: {
      "src": require("../../assets/images/icon001.png")
    }
  }), _vm._v(_vm._s(_vm.dynamic.circleName) + " | " + _vm._s(_vm.dynamic.createTime))])])]), _vm._v(" "), (_vm.dynamic.description !== undefined) ? _c('div', {
    staticClass: "titleDiv",
    attrs: {
      "id": "content"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.titleFlag ? _vm.dynamic.description.substr(0, 60) : _vm.dynamic.description))]), _vm._v(" "), (_vm.dynamic.description.length > 60 && _vm.titleFlag) ? _c('a', {
    on: {
      "click": _vm.descClick
    }
  }, [_vm._v("...全文")]) : _vm._e(), _vm._v(" "), (_vm.dynamic.description.length > 60 && !_vm.titleFlag) ? _c('a', {
    on: {
      "click": _vm.descClick
    }
  }, [_vm._v("...收起")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mediaDiv"
  }, [_vm._l((_vm.dynamic.resources), function(item, index) {
    return (_vm.dynamic.resourceType === 0) ? _c('div', {
      key: index,
      staticClass: "img"
    }, [_c('img', {
      attrs: {
        "src": item.thumbnailHDUrl
      },
      on: {
        "click": _vm.previewImage
      }
    })]) : _vm._e()
  }), _vm._v(" "), (_vm.dynamic.resourceType === 1) ? _c('div', {
    staticClass: "videoDiv"
  }, [_c('video-player', {
    ref: "videoPlayer",
    staticClass: "video-player vjs-custom-skin",
    attrs: {
      "playsinline": true,
      "options": _vm.playerOptions
    }
  })], 1) : _vm._e()], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('previewer', {
    ref: "previewer",
    attrs: {
      "list": _vm.previewImgUrl
    }
  })], 1)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e2ca0c5"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/share/dynamicShare_in.vue
// module id = 449
// module chunks = 1